import classNames from 'classnames';
import { Button, Indicator, Popover, PopoverButton, PopoverItem, StyledPopoverPanel } from '@crazyegginc/hatch';

function TechOptionIcon({ option }) {
  if (!option?.icon) {
    return null;
  }

  if (typeof option.icon === 'string') {
    return (
      <img src={option.icon} alt={`${option.label} logo`} className={classNames(`w-5 h-5`, option.iconClassName)} />
    );
  }

  const IconComponent = option.icon;
  return <IconComponent className={classNames(`w-5 h-5`, option.iconClassName)} aria-label={`${option.label} logo`} />;
}

export function TechSelector({ techOptions = [], selectedTechOption = null, onSelectTech }) {
  return (
    <Popover className="relative">
      {({ open }) => (
        <>
          <PopoverButton
            as={Button}
            variant="secondary"
            className={`h-[40px] w-full min-w-0 md:w-auto md:min-w-[236px] justify-between px-4 py-2.5 bg-white ${
              open ? '!border-dodger-blue-500' : ''
            }`}
          >
            <span className="flex min-w-0 items-center gap-3">
              <TechOptionIcon option={selectedTechOption} />
              <span className="truncate text-base font-medium text-black-pearl-500">
                {selectedTechOption ? selectedTechOption.label : 'Select a technology'}
              </span>
            </span>
            <Indicator type="dropdown" className="ml-2.5 fill-current text-black-pearl-500" />
          </PopoverButton>

          <StyledPopoverPanel
            align="left"
            className="!w-full md:!w-[236px] !max-h-[min(70dvh,359px)] !overflow-y-auto !p-2 !rounded-md"
          >
            {({ close }) => (
              <>
                {techOptions.map((option) => (
                  <PopoverItem
                    key={option.key}
                    className="!px-3 !py-2 !rounded !h-10"
                    onClick={() => {
                      onSelectTech?.(option.key);
                      close();
                    }}
                  >
                    <span className="flex items-center gap-2">
                      <TechOptionIcon option={option} />
                      <span
                        className={`text-base text-black-pearl-500 leading-6 ${
                          selectedTechOption?.key === option.key ? 'font-bold' : 'font-normal'
                        } truncate`}
                      >
                        {option.label}
                      </span>
                    </span>
                  </PopoverItem>
                ))}
              </>
            )}
          </StyledPopoverPanel>
        </>
      )}
    </Popover>
  );
}
